<div *ngIf="!showRegistrationForm">
  <air-form
    #formComponent
    [controls]="form"
    [showMandatory]="true"
    (submitted)="submitValues($event)"
    [showInvalidToast]="true"
    [userEventSource]="userEventSource"
    [alternateReCaptchaActions]="[reCaptchaAction.activateRegistrationCampaign]"
  >
    <button
      type="button"
      (click)="submit($event)"
      class="button form__button button--full-width button--cta"
      [airButtonLoading]="isSubmitting"
      [disabled]="formDisabled"
    >
      <span>{{ "campaign_registration.label.join" | translate }}</span>
    </button>
  </air-form>
  <p class="form__mandatory-label">{{ "general.label.mandatory_fields" | translate }}</p>
</div>
<ng-container *ngIf="showRegistrationForm">
  <div class="form-section">
    <h2>{{ content.registrationText?.title }}</h2>
    <div [internalInnerHtml]="content.registrationText?.body" [userEventSource]="userEventSource"></div>
    <div *ngIf="enableLightCampaignAlternateReCaptcha" class="form-group--grecaptcha">
      <air-recaptcha-fallback></air-recaptcha-fallback>
    </div>
    <p *ngIf="campaignRegistrationSettings.allowLightRegistration">
      <a
        (click)="registerLightAccount($event)"
        class="button form__button button--border button--transparent"
        [airButtonLoading]="isSubmitting"
        [class.button--disabled]="formDisabled"
      >
        {{ "campaign_registration.label.skip_this_step" | translate }}
      </a>
    </p>
  </div>
  <air-registration-form
    [content]="content"
    [campaignRegistrationValues]="campaignRegistrationValues"
    [newsletterSuggestionModal]="newsletterSuggestionModal"
    [userEventSource]="userEventSource"
  ></air-registration-form>
</ng-container>
